/**
 *
 * 通信中の全体を被せるローディング画面
 *
 */
import React from 'react';
import styled from 'styled-components';
import Spinner, { Props as SpinnerProps } from 'src/components/atoms/spinner/Spinner';
import StyleConfig from 'src/constants/StyleConfig';

type Props = SpinnerProps;

export const SpinnerModal = ({ ...props }: Props) => {
  const isShow = props.isLoading === true;
  return (
    <Styled isShow={isShow}>
      <div className="inner">
        <div className="item">
          <Spinner {...props} />
          <p>通信中です。しばらくお待ち下さい</p>
        </div>
      </div>
    </Styled>
  );
};

const Styled = styled.aside<{ isShow: boolean }>`
  display: ${({ isShow }) => (isShow ? 'block' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.7);
  z-index: 9999;
  > .inner {
    position: relative;
    width: 100%;
    height: 100%;
    .item {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      text-align: center;
      > p {
        margin: ${StyleConfig.HELPER.M4};
      }
    }
  }
`;

export default SpinnerModal;
